import React, { PropTypes } from 'react';
import Modal from 'react-modal';
import Translate from 'react-translate-component';
import EnvelopeOpen from '../../svg/envelope-open';
import ShieldCheck from '../../svg/shield-check';
import Umbrella from '../../svg/umbrella';
import Heart from '../../svg/heart';
import Pencil from '../../svg/pencil';
import FileAdd from '../../svg/file-add';

class RegisterAssignmentInfoModal extends React.Component {

  static propTypes = {
    close: PropTypes.func
  };

  render () {
    return (
      <Modal
        className='modal'
        contentLabel=''
        isOpen
        onRequestClose={this.props.close}>
        <div className='modal-content'>
          <button className='close' onClick={this.props.close}/>
          <div className='info-modal-container'>
            <Translate
              className='info-modal-title'
              content='REGISTER_ASSIGNMENT_INFO_MODAL_TITLE'
            />
            <div className='info-modal-column-container'>
              <div className='info-modal-column'>
                <Translate className='info-modal-column-title' content='REGISTER_ASSIGNMENT_INFO_MODAL_HOW_TITLE'/>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <EnvelopeOpen
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_ENVELOPE_OPEN'/>
                </div>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <Pencil
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_PENCIL'/>
                </div>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <FileAdd
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_FILE_ADD'/>
                </div>
              </div>
              <div className='info-modal-column'>
                <Translate
                  className='info-modal-column-title'
                  content='REGISTER_ASSIGNMENT_INFO_MODAL_BENEFITS_TITLE'/>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <Umbrella
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_UMBRELLA'/>
                </div>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <ShieldCheck
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_SHIELD_CHECK'/>
                </div>
                <div className='info-modal-row'>
                  <span className='info-modal-icon'>
                    <Heart
                      width='20'
                      height='20'
                      colorSchema='primary'
                    />
                  </span>
                  <Translate content='REGISTER_ASSIGNMENT_INFO_MODAL_HEART' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    );
  }

}

export default RegisterAssignmentInfoModal;



/** WEBPACK FOOTER **
 ** ./src/components/modal/register-assignment-info-modal/register-assignment-info-modal.js
 **/